var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-activities';
                    var viewUrl = 'sprite.svg#view-icon-activities';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-activities#icon-activities';
                            viewUrl = 'sprite.svg?icon-activities#view-icon-activities';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };